import { createAsyncThunk } from '@reduxjs/toolkit';

import doFetch from 'utils/doFetch';

import type { AppGetState } from '../../index';

const getPaymentsStatus = createAsyncThunk(
  'paymentsMethods/getPaymentsStatus',
  async (transaction_id: string, { getState }) => {
    const apiPointName = 'getPaymentsStatus';
    const store = (getState as AppGetState)();
    const token = store.jwt.token;
    let headers = {};

    if (token) {
      headers = {
        ...headers,
        Authorization: `Bearer ${token}`,
      };
    }

    return await doFetch<typeof apiPointName>({
      apiPointName,
      queryParams: {
        transaction_id,
      },
      body: null,
      headers,
    });
  },
);

export default getPaymentsStatus;
